import { render, staticRenderFns } from "./ProjectContentModalView.vue?vue&type=template&id=5a9a6c64&scoped=true&"
import script from "./ProjectContentModalView.vue?vue&type=script&lang=js&"
export * from "./ProjectContentModalView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectContentModalView.vue?vue&type=style&index=0&id=5a9a6c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a6c64",
  null
  
)

export default component.exports